import React, { useState } from 'react';
import './questions-block.scss';
import SubmitIcon from '/react4xp/parts/questions-block/icons/submit-icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { faYoutube, faTiktok, faGooglePlus, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { localize } from '/react4xp/mixins/helpers';
import { Col, Row, Space } from 'antd';
import { QuestionsBlock } from '/react4xp/parts/questions-block/questions-block.type';

function QuestionsBlock(props: QuestionsBlock.Props) {
    const [query, setQuery] = useState<string>('');

    const handleSubmitQuery = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!query.trim()) return;

        const openAssistantEvent = new CustomEvent('openAssistant');
        window.dispatchEvent(openAssistantEvent);
        const messageEvent = new CustomEvent('assistantMessage', { detail: { query } });
        setTimeout(() => {
            window.dispatchEvent(messageEvent);
        }, 300);
        setQuery('');
    };

    return (
        <div className="questions-block">
            <Row
                className="calendar__row"
                style={{ alignItems: 'center', justifyContent: 'start' }}
            >
                <Col
                    span={24}
                    offset={1}
                    className="question"
                >
                    {localize('any-questions', props.translations)}
                </Col>
            </Row>
            <Space
                direction="vertical"
                size="small"
                style={{ width: '100%' }}
            >
                <Row
                    className="calendar__row"
                    gutter={[0, 40]}
                    style={{ alignItems: 'center', justifyContent: 'start' }}
                >
                    <Col
                        span={12}
                        offset={1}
                        className="question_item"
                    >
                        {localize('question_to_a_virtual_assistant', props.translations)}
                    </Col>
                    <Col
                        span={6}
                        className="question_item"
                    >
                        {localize('social_networks_and_messengers', props.translations)}
                    </Col>
                </Row>
                <Row
                    className="calendar__row"
                    gutter={[0, 40]}
                    style={{ alignItems: 'center', justifyContent: 'start' }}
                >
                    <Col
                        span={12}
                        offset={1}
                        style={{ display: 'flex' }}
                    >
                        <form
                            className="form"
                            onSubmit={(e) => handleSubmitQuery(e)}
                        >
                            <input
                                className="input"
                                type="text"
                                placeholder={localize('question', props.translations)}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                            <button
                                type="submit"
                                className="btn btn__submit"
                                style={{ width: '87px', borderRadius: '0 4px 4px 0' }}
                            >
                                <SubmitIcon />
                            </button>
                        </form>
                    </Col>
                    <div className="container__links">
                        <Col span={1}>
                            <a
                                href="https://www.facebook.com/kgd.gov.kz/"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faFacebook}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://www.instagram.com/press_kyzmet_kgd/"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faInstagram}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://t.me/kgdmfrk"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faTelegram}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://twitter.com/KGD_MF_RK"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faXTwitter}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://www.youtube.com/@salykgovkz/featured"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faYoutube}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://plus.google.com/u/0/117682662040777385365/posts"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faGooglePlus}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                        <Col span={1}>
                            <a
                                href="https://www.tiktok.com/@qr_mkk"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faTiktok}
                                    className="icon-color"
                                />
                            </a>
                        </Col>
                    </div>
                </Row>
            </Space>
        </div>
    );
}

export default QuestionsBlock;
